import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DocumentUploader from 'modules/documents/components/Documents/DocumentUploader'
import FolderCustomFields from 'modules/documents/components/FolderCustomFields'
import type Employee from 'modules/employees/store/models/Employee'
import type DocumentForm from 'modules/timeoff/lib/DocumentForm'
import type Leave from 'modules/timeoff/store/models/Leave'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

import DocumentList from './List'

interface Props {
  employee?: Employee | null | undefined
  leave?: Leave
  documentForm: DocumentForm
  customFieldsForms: Form[]
  leaveType: LeaveType | null | undefined
  onDocumentDropped?: () => void
  contractVersions: ContractVersions
}

class Documents extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    makeObservable(this, {
      canManageLeaveDocuments: computed,
    })
  }

  get canManageLeaveDocuments(): boolean {
    const { employee, leave } = this.props

    if (leave) return leave.policy.can('manageLeaveDocuments')

    if (employee) return employee.policy.can('manageLeavesDocuments')

    return false
  }

  showCustomFields = () => {
    const { leave } = this.props
    const file = this.props.documentForm.get('file').value

    if (!leave) return !!file

    return file || leave.documents.length > 0
  }

  customFieldRender = () => {
    if (!this.showCustomFields()) return null

    return (
      <Box paddingTop="s24">
        <FolderCustomFields
          customFieldsForms={this.props.customFieldsForms}
          title={i18n.t('time_off.custom_fields.title')}
          description={i18n.t('time_off.custom_fields.description')}
        />
      </Box>
    )
  }

  placeholder() {
    const { leaveType } = this.props

    if (!leaveType) return i18n.t('time_off.leave_document')

    return leaveType && leaveType.attributes.is_attachment_mandatory
      ? i18n.t('time_off.leave_document_mandatory')
      : i18n.t('time_off.leave_document')
  }

  render() {
    const { documentForm, leave, onDocumentDropped, contractVersions } = this.props

    return (
      <FormRow>
        <DocumentList
          readonly={!this.canManageLeaveDocuments}
          leave={leave}
          contractVersions={contractVersions}
        />
        <DocumentUploader
          readonly={!this.canManageLeaveDocuments}
          field={documentForm.get('file')}
          placeholder={this.placeholder()}
          customFieldsRender={this.customFieldRender}
          onDropped={onDocumentDropped}
        />
      </FormRow>
    )
  }
}

export default observer(Documents)
